import { Layout } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const Content = styled(Layout.Content).attrs({
  className: 'app-shell-main'
})`
  padding: 18px 24px;
  min-height: calc(100vh - 64px);
  background-color: ${APP_SHELL_THEME.pageBg};
  color: ${APP_SHELL_THEME.text};
`;
